import { useTranslation } from "react-i18next";
import { Card, Flex, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { CheckCircleOutlined } from "@ant-design/icons";

import GlobeIcon from "@/assets/icons/globe.svg?react";
import CommunityIcon from "@/assets/icons/community.svg?react";
import BaseButton from "@/components_v2/Button/BaseButton";
import BaseSvgRenderer from "@/components_v2/Svg/BaseSvgRenderer";
import {
  BUTTON_TYPES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants.js";

import "./styles.css";

const { Title, Text } = Typography;

const SubmissionSuccessPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="submission-success-container">
      <Card className="submission-success-card">
        <Flex vertical align="center" gap="large">
          <CheckCircleOutlined className="success-icon" />
          <h1 className="header-l-medium">
            {t("surveyViews.labels.reportSubmittedSuccessfully")}
          </h1>
          <Text>{t("surveyViews.labels.reportSubmittedDescription")}</Text>

          <Flex
            className="report-versions-container"
            justify="center"
            gap="large"
          >
            <Card className="report-version-card-public">
              <Flex vertical align="center" gap="small">
                <BaseSvgRenderer component={GlobeIcon} width="40" height="40" />
                <h2 className="header-m-medium">
                  {t("surveyViews.labels.publicWebsiteVersion")}
                </h2>
                <Text>
                  {t("surveyViews.labels.publicWebsiteVersionDescription")}
                </Text>
              </Flex>
            </Card>
            <Card className="report-version-card-community">
              <Flex vertical align="center" gap="small">
                <BaseSvgRenderer
                  component={CommunityIcon}
                  width="40"
                  height="40"
                />
                <h2 className="header-m-medium">
                  {t("surveyViews.labels.communityVersion")}
                </h2>
                <Text>
                  {t("surveyViews.labels.communityVersionDescription")}
                </Text>
              </Flex>
            </Card>
          </Flex>

          <Text>{t("surveyViews.labels.manageReportsHint")}</Text>

          <Flex gap="small">
            <BaseButton
              variant={BUTTON_VARIANTS.TERTIARY}
              to={"/"}
              type={BUTTON_TYPES.LINK}
            >
              {t("buttons.returnToDashboard")}
            </BaseButton>
            <BaseButton
              variant={BUTTON_VARIANTS.PRIMARY}
              to={"/reports/views"}
              type={BUTTON_TYPES.LINK}
            >
              {t("buttons.goToPublishAndShare")}
            </BaseButton>
          </Flex>
        </Flex>
      </Card>
    </div>
  );
};

export default SubmissionSuccessPage;
